export default {
  total_responses: 'Responses',
  top_two_box: 'Satisfaction (top 2)',
  average_score: 'Average score',
  keep_reading: 'Keep reading?',
  keep_reading_yes: 'Yes',
  keep_reading_maybe: 'Maybe',
  keep_reading_no: 'No',
  distribution_title: 'Smileyometer distribution',
  breakdown_title: 'Results by segment',
  by_grade: 'Grade',
  by_school: 'School',
  by_country: 'Country',
  col_segment: 'Segment',
  col_responses: 'Responses',
  col_top_two_box: 'Satisfaction (top 2)',
  col_average: 'Average',
  scores: {
    1: 'Very dissatisfied',
    2: 'Dissatisfied',
    3: 'Neutral',
    4: 'Satisfied',
    5: 'Very satisfied',
  },
};
